<h1>
  <a class="home-link" [routerLink]="['/' + getHomePath()]">
    <i class="fa fa-home" aria-hidden="true"></i>
    {{'Manage all users' | translate}}
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="getLoading()" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>
  <div class="above-table-container">
    <div fxLayout="row">
      <form [formGroup]="getSearchForm()" fxLayout="column" class="ng" fxFlex.xs="100" fxFill
            (ngSubmit)="submitRequest(); openMobileSearch()" [ngClass]="{'mobile-input': getMobileSearchOpen()}">

        <div fxLayout="row" fxLayoutGap="20px" fxLayout.xs="column">
          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100">
            <label class="control-label" fxFlex="35">
              {{'Status' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getActiveStates()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                (change)="onSelectStatus($event)"
                [(ngModel)]="selectedStatus"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="status">>
              </ng-select>
            </div>
          </div>

          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100">
            <label class="control-label" fxFlex="35">
              {{'Target Group' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getTargetGroups()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                (change)="onSelectTGroup($event)"
                [(ngModel)]="selectedTargetGroup"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="targetGroup">>
              </ng-select>
            </div>
          </div>

          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100">
            <label class="control-label" fxFlex="35">
              {{'User Confirmation' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getConfirmationStates()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                (change)="onSelectConfirmation($event)"
                [(ngModel)]="selectedConfirmed"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="confirmation">>
              </ng-select>
            </div>
          </div>

          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100">
            <label class="control-label" fxFlex="35">
              {{'Customer Administrator' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getAdminStates()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                (change)="onSelectAdmin($event)"
                [(ngModel)]="selectedCustomerAdmin"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="admin">>
              </ng-select>
            </div>
          </div>

          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100">
            <label class="control-label" fxFlex="35">
              {{'Country' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getCountryCode()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                (change)="onSelectCountryCode($event)"
                [(ngModel)]="selectedCountry"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="countryCode">>
              </ng-select>
            </div>
          </div>

        </div>

        <div fxLayout="row" fxLayoutGap="66px">
          <div fxLayoutAlign="start" fxFlex="100">

            <button class="btn btn-secondary btn-search" type="submit">
              <i class="fa fa-search fa-lg" aria-hidden="true"></i>
            </button>

            <div class="search input-container" fxFlexFill>
              <input
                class="form-control form-control-border"
                type="text"
                formControlName="searchTerm"
                autocomplete=off
                placeholder="{{'Search...' | translate}}">
              <i *ngIf="getSearchForm().controls.searchTerm.value && getSearchForm().controls.searchTerm.value.length"
                 class="fa fa-times fa-lg" aria-hidden="true"
                 (click)="clearInputField()"></i>
            </div>
          </div>

          <div fxLayoutAlign="end">
            <div class="above-table">
              <button class="btn btn-info add-btn" type="button" (click)="goToNewUserPage()">
                <i class="fa fa-plus fa-lg" aria-hidden="true"></i>
                <span fxHide.xs> {{'Create new user' | translate}} </span>
              </button>
            </div>
          </div>

        </div>

      </form>
    </div>

  </div>

  <div class="form-container-content" fxLayout="column">
    <ul fxLayout="column" fxFlex fxHide.xs>
      <li fxLayout fxFlex class="table-header">
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
             [ngClass]="{'sorting': sortingObj.sortCustomerNumberField.sorting == undefined, 'sorting_asc': sortingObj.sortCustomerNumberField.sorting == true, 'sorting_desc': sortingObj.sortCustomerNumberField.sorting == false}"
             (click)="sortTable(sortingObj.sortCustomerNumberField)">
          <h4>{{'Company-ID' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="15"
             [ngClass]="{'sorting': sortingObj.sortCompanyField.sorting == undefined, 'sorting_asc': sortingObj.sortCompanyField.sorting == true, 'sorting_desc': sortingObj.sortCompanyField.sorting == false}"
             (click)="sortTable(sortingObj.sortCompanyField)">
          <h4>{{'Company' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
             [ngClass]="{'sorting': sortingObj.sortLastNameField.sorting == undefined, 'sorting_asc': sortingObj.sortLastNameField.sorting == true, 'sorting_desc': sortingObj.sortLastNameField.sorting == false}"
             (click)="sortTable(sortingObj.sortLastNameField)">
          <h4>{{'Last name' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
             [ngClass]="{'sorting': sortingObj.sortFirstNameField.sorting == undefined, 'sorting_asc': sortingObj.sortFirstNameField.sorting == true, 'sorting_desc': sortingObj.sortFirstNameField.sorting == false}"
             (click)="sortTable(sortingObj.sortFirstNameField)">
          <h4>{{'First name' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
             [ngClass]="{'sorting': sortingObj.sortCountryCodeField.sorting == undefined, 'sorting_asc': sortingObj.sortCountryCodeField.sorting == true, 'sorting_desc': sortingObj.sortCountryCodeField.sorting == false}"
             (click)="sortTable(sortingObj.sortCountryCodeField)">
          <h4>{{'Country' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
             [ngClass]="{'sorting': sortingObj.sortStatusField.sorting == undefined, 'sorting_asc': sortingObj.sortStatusField.sorting == true, 'sorting_desc': sortingObj.sortStatusField.sorting == false}"
             (click)="sortTable(sortingObj.sortStatusField)">
          <h4>{{'Status' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
             [ngClass]="{'sorting': sortingObj.sortIsCustomerAdminField.sorting == undefined, 'sorting_asc': sortingObj.sortIsCustomerAdminField.sorting == true, 'sorting_desc': sortingObj.sortIsCustomerAdminField.sorting == false}"
             (click)="sortTable(sortingObj.sortIsCustomerAdminField)">
          <h4>{{'Customer Administrator' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="15">
          <h4>{{'Target Group' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="15"
             [ngClass]="{'sorting': sortingObj.sortCreationDateField.sorting == undefined, 'sorting_asc': sortingObj.sortCreationDateField.sorting == true, 'sorting_desc': sortingObj.sortCreationDateField.sorting == false}"
             (click)="sortTable(sortingObj.sortCreationDateField)">
          <h4>{{'Creation date' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="15"
             [ngClass]="{'sorting': sortingObj.sortLastLoginField.sorting == undefined, 'sorting_asc': sortingObj.sortLastLoginField.sorting == true, 'sorting_desc': sortingObj.sortLastLoginField.sorting == false}"
             (click)="sortTable(sortingObj.sortLastLoginField)">
          <h4>{{'Last login' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10"
             [ngClass]="{'sorting': sortingObj.sortConfirmedField.sorting == undefined, 'sorting_asc': sortingObj.sortConfirmedField.sorting == true, 'sorting_desc': sortingObj.sortConfirmedField.sorting == false}"
             (click)="sortTable(sortingObj.sortConfirmedField)">
          <h4>{{'User Confirmation' | translate}}</h4>
        </div>
        <div fxLayout fxLayoutAlign="end center" fxFlex="5"></div>
      </li>

      <li fxLayout class="table-items" *ngFor="let user of getListOfUsers()">
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
          <h5 class="table-item">{{user.customerNumber}}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="15">
          <h5 class="table-item">{{user.customerName}}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
          <h5 class="table-item">{{user.lastName}}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
          <h5 class="table-item">{{user.firstName}}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
          <h5 class="table-item">{{user.countryCode | translate }}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
          <h5 class="table-item">{{(true === user.isActive ? 'active' : 'not-active') | translate }}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
          <h5 class="table-item">{{(true === user.isCustomerAdmin ? 'Yes' : 'No') | translate }}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="15">
          <h5 class="table-item">{{user.targetGroup | translate}}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="15">
          <h5 class="table-item">{{user.creationDate | localizedDate}} {{user.creationDate | localizedDate:'shortTime'}}</h5>
        </div>
        <div class="last-login-time" fxLayout fxLayoutAlign="space-around center" fxFlex="15">
          <h5 class="table-item">{{user.lastLogin | localizedDate}} {{user.lastLogin | localizedDate:'shortTime'}}</h5>
        </div>
        <div fxLayout fxLayoutAlign="space-around center" fxFlex="10">
          <h5 class="table-item fas" [ngClass]="{'fa-check': user.confirmed == true, 'fa-times': user.confirmed == false }"></h5>
        </div>

        <div fxLayout fxLayoutAlign="end center" fxFlex="5" class="buttons-container">
          <button (click)="goToEditPage(user)" class="btn btn-primary update-btn btn-icon" type="button">
            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
          </button>
          <!--            <app-delete-modal
                      [first-name-of-user-to-delete]="user.firstName"
                      [last-name-of-user-to-delete]="user.lastName"
                      (onHide)="deleteUser($event, user)"></app-delete-modal>-->
        </div>
      </li>
    </ul>

    <!--     Appears if device is a mobile phone-->
    <div class="table-mobile-layout" fxLayout="column" fxHide.gt-xs>
      <div *ngFor="let user of getListOfUsers(); let i = index" fxLayout>
        <div fxLayout fxLayout="column" fxFlex="80">
          <div fxLayout>
            <label fxFlex="25">{{'Company-ID' | translate}}: </label>
            <span fxFlex="5"></span>
            <span fxLayoutAlign="start center">{{user.customerNumber}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Company' | translate}}: </label>
            <span fxFlex="5"></span>
            <span>{{user.customerName}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Last name' | translate}}: </label>
            <span fxFlex="5"></span>
            <span fxLayoutAlign="start center">{{user.lastName}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'First name' | translate}}: </label>
            <span fxFlex="5"></span>
            <span fxLayoutAlign="start center">{{user.firstName}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Country' | translate}}: </label>
            <span fxFlex="5"></span>
            <span fxLayoutAlign="start center">{{user.countryCode | translate }}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Status' | translate}}: </label>
            <span fxFlex="5"></span>
            <span>{{(true === user.isActive ? 'active' : 'not-active') | translate }}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Customer Administrator' | translate}}: </label>
            <span fxFlex="5"></span>
            <span fxLayoutAlign="start center">{{(true === user.isCustomerAdmin ? 'Yes' : 'No') | translate }}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Target Group' | translate}}: </label>
            <span fxFlex="5"></span>
            <span fxLayoutAlign="start center">{{user.targetGroup | translate}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Creation date' | translate}}: </label>
            <span fxFlex="5"></span>
            <span
              fxLayoutAlign="start center">{{user.creationDate | localizedDate}} {{user.creationDate | localizedDate:'shortTime'}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="25">{{'Last login' | translate}}: </label>
            <span fxFlex="5"></span>
            <span fxLayoutAlign="start center">{{user.lastLogin | localizedDate}} {{user.lastLogin | localizedDate:'shortTime'}}</span>
          </div>
          <div *ngIf="i < user.length-1" class="divider"></div>
        </div>
        <div fxLayout="column" fxFlex="20" class="mobileButtonsContainer">
          <button (click)="goToEditPage(user)" class="btn btn-primary update-btn btn-icon" type="button">
            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
          </button>
          <!--<app-delete-modal
            [first-name-of-user-to-delete]="user.firstName"
            [last-name-of-user-to-delete]="user.lastName"
            (onHide)="deleteUser($event, user)"></app-delete-modal>-->
        </div>
      </div>
    </div>

    <app-pagination
      [totalNumberOfItems]="getTotalNumberOfItems()"
      [pageSize]="getItemsPerPage()"
      (pageSizeChange)="onPageSizeChange($event)"
      (pageChange)="onPageChange($event)">
    </app-pagination>

  </div>
</div>
<div class="divider"></div>
